import { submitContactUs } from '@gonfalon/openapi/operations/submitContactUs';
import { useMutation } from '@tanstack/react-query';

import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export function useSubmitContactUs() {
  return useMutation({
    mutationFn: async (input: Parameters<typeof submitContactUs>[0]) =>
      reactQueryResponseAdapter(submitContactUs(input)),
  });
}
